import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import cx from 'classnames';

import styles from '../style.module.scss';
import { ExternalFormWidgetContext } from '..';

export const PardotFormView = ({ form, uid, widget, breakpoint }) => {
  const context = React.useContext(ExternalFormWidgetContext);
  const widgetContextRef = React.useRef(null);
  var embedCode = _.get(form.configuration, "embedCode", null);
  const [currentUid, setCurrentUid] = useState(null);

  const height = _.get(widget, `properties.${breakpoint}.layout.height`);
  embedCode = embedCode.replace(/\bheight="(\d+)"/g, `height="${height}"`);

  useEffect(() => {
    widgetContextRef.current = context;
  }, [context]);

  useEffect(() => {
    if (currentUid && context.onFormSubmit) {
      //Attaching message event listner
      var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
      var eventer = window[eventMethod];
      var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

      // Listen to message from child window
      eventer(messageEvent, handleFormSubmit, false);
    }
  }, [currentUid, context.onFormSubmit])

  const handleFormSubmit = (e) => {
    const widgetContext = widgetContextRef.current;

    if (widgetContext && e.data.type === 'PARDOT_FORM_SUBMISSION') {
      var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
      var deEventer = window[detachEventMethod];
      var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

      var email = e.data.payload.email;

      var contactRequest = {
        email: email
      }

      widgetContext.onFormSubmit(contactRequest, widgetContext.parent);

      deEventer(messageEvent, handleFormSubmit, false);

      return;
    }
  }

  const handleClick = () => {
    if(currentUid == uid) {
      return;
    }

    setCurrentUid(uid);
  };

  return (
    <div id={`pardot_form_${breakpoint}_${uid}`} style={{height: height}} className={cx(styles.externalForm, styles.pardotForm)} onMouseOver={handleClick}>
      <div style={{ height: height }} dangerouslySetInnerHTML={{ __html: embedCode }} />
    </div>
  )
}
